import React from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css';
import { PhoneInputWrapper } from './PhoneNumberInput.styles';
import { useState } from 'react';
import { useEffect } from 'react';
import { getCountryCallingCode, parsePhoneNumberFromString } from 'libphonenumber-js';
import ErrorContainer from '../../ErrorContainer/ErrorContainer';

const PhoneNumberInput = ({ phone, setPhone, className, initialPhoneNumber, label, error, hideErrorMessage }) => {
  const [country, setCountry] = useState('us');

  useEffect(() => {
    setTimeout(() => {
      const prefix = '+' + getCountryCallingCode('US');
      setPhone(prefix);
    }, 10);
  }, [setPhone]);

  const extractCountryCode = phoneNumber => {
    const parsedPhone = parsePhoneNumberFromString(phoneNumber);
    if (parsedPhone && parsedPhone.country) {
      return parsedPhone.country.toLowerCase();
    }
    return 'us';
  };

  useEffect(() => {
    const extractedCountryCode = extractCountryCode(initialPhoneNumber + '');
    setCountry(extractedCountryCode);
  }, [initialPhoneNumber]);

  return (
    <PhoneInputWrapper className={className}>
      <PhoneInput
        autoFormat={false}
        countryCodeEditable={true}
        country={country}
        specialLabel={label}
        inputProps={{ value: phone }}
        onChange={(value, _, e, formattedValue) => {
          setPhone(formattedValue);
        }}
      />
      {!hideErrorMessage && <ErrorContainer errorText={error} twoLine={false} />}
    </PhoneInputWrapper>
  );
};

export default PhoneNumberInput;
